/**
 * Tables copied in the device-to-device P2P transfer: the CLIENT-writable
 * subset of `USER_DATA_TABLES`, in INSERTION order
 * (parents first): `exercise` and `routine`
 * before bridge table `routine_exercise`;
 * `workout_session` before `workout_set`.
 *
 * Excludes `routine_version`. History is server-materialized
 * (API write-path), READ-ONLY on the client, and arrives via sync. The server
 * re-derives it from imported routines; copying it would create local rows
 * the client cannot upload. It is also absent from `USER_DATA_TABLES`
 * (FK-RESTRICT, never guest CRUD). Transfer and sweep therefore exclude it.
 *
 * VALUES in internal `*_version_id` columns (e.g.
 * `workout_session.routine_version_id`) remain intact inside rows. Only ROWS
 * from the `routine_version` TABLE are excluded.
 */
export const P2P_TRANSFER_TABLES = [
  "exercise",
  "routine",
  "routine_exercise",
  "workout_session",
  "workout_set",
  "body_measurement",
  "attachment",
] as const;
